import { Badge } from "@mantine/core";
import type { CardRefundQueueState } from "@/firestore/cardRefunds";
import { REFUND_STATE_LABELS } from "@/pages/card-refunds/presentation";

const COLORS: Record<CardRefundQueueState, string> = {
  awaitingProvider: "gray",
  toPay: "orange",
  authorizing: "blue",
  assigned: "blue",
  releasing: "blue",
  verifying: "blue",
  done: "green",
  cancelled: "gray",
  needsReview: "red",
};

export function CardRefundStatus({ state }: { state: CardRefundQueueState }) {
  return <Badge color={COLORS[state] ?? "gray"}>{REFUND_STATE_LABELS[state] ?? state}</Badge>;
}
